var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-row',[_c('v-col',[_c('v-btn',{attrs:{"dark":"","color":"white","outlined":"","small":""},on:{"click":_vm.backToEventList}},[_c('span',[_vm._v(_vm._s(_vm.$t('eventPage.backToEventList')))])])],1)],1),_c('EventPage')],1)}
var staticRenderFns = []

export { render, staticRenderFns }